import { render, staticRenderFns } from "./CampusCustomerData.vue?vue&type=template&id=882ec528&"
import script from "./CampusCustomerData.vue?vue&type=script&lang=js&"
export * from "./CampusCustomerData.vue?vue&type=script&lang=js&"
import style0 from "./CampusCustomerData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports